var IMG = (window.AK && window.AK.img) || 'images/ak/';
(() => {
  const $ = (s, r = document) => r.querySelector(s);
  const $$ = (s, r = document) => [...r.querySelectorAll(s)];
  const money = n => '$' + n.toFixed(2);
  const store = {
    get(k, d) { try { return JSON.parse(localStorage.getItem(k)) ?? d; } catch { return d; } },
    set(k, v) { try { localStorage.setItem(k, JSON.stringify(v)); } catch {} }
  };

  // Countdown timers are driven by js/campaign.js (real campaign end dates only).
  const today = new Date().toLocaleDateString('en-US', { month: 'short', day: 'numeric' });
  const setToday = () => { const t = new Date().toLocaleDateString('en-US', { month: 'short', day: 'numeric' }); $$('[data-today]').forEach(el => { if (el.textContent !== t) el.textContent = t; }); };
  setToday(); setInterval(setToday, 60000);
  $$('[data-year]').forEach(el => el.textContent = new Date().getFullYear());

  /* ---------- Header shadow + sticky ATC ---------- */
  const header = $('#header'), sticky = $('[data-sticky]'), mainAtc = $('.btn--atc');
  const onScroll = () => {
    header.classList.toggle('scrolled', scrollY > 10);
    const r = mainAtc.getBoundingClientRect();
    sticky.classList.toggle('show', r.bottom < 0);
  };
  addEventListener('scroll', onScroll, { passive: true }); onScroll();

  /* ---------- Drawers ---------- */
  const overlay = $('[data-overlay]');
  const openDrawer = id => {
    if (id === 'search') { const s = $('#search'); s.hidden = !s.hidden; if (!s.hidden) $('input', s).focus(); return; }
    $('#' + id).classList.add('open'); $('#' + id).setAttribute('aria-hidden', 'false');
    if (id === 'cart' && typeof window.__akReplayShip === 'function') window.__akReplayShip();
    overlay.classList.add('show'); document.body.style.overflow = 'hidden';
  };
  const closeAll = () => {
    $$('.drawer.open').forEach(d => { d.classList.remove('open'); d.setAttribute('aria-hidden', 'true'); });
    overlay.classList.remove('show'); document.body.style.overflow = '';
  };
  document.addEventListener('click', e => {
    const o = e.target.closest('[data-open]'); if (o) openDrawer(o.dataset.open);
    const c = e.target.closest('[data-close]');
    if (c) { c.dataset.close === 'search' ? ($('#search').hidden = true) : closeAll(); }
  });
  overlay.addEventListener('click', closeAll);
  $$('.drawer__nav a').forEach(a => a.addEventListener('click', closeAll));
  addEventListener('keydown', e => { if (e.key === 'Escape') { closeAll(); closeExit(); $('[data-lightbox]').hidden = true; } });

  /* ---------- Gallery ---------- */
const imgs = [1, 2, 3, 4, 5, 6, 7, 8].map(n => n === 3 ? IMG + 'social-nia-simmons.webp' : `${IMG}product-0${n}.jpg`);
  const social = [1, 2]; // social-style slides (0-based)
  const track = $('[data-track]'), thumbs = $('[data-thumbs]');
  track.innerHTML = imgs.map((s, i) => `<img src="${s}" alt="Akyilia Veil Mask image ${i + 1}" ${i ? 'loading="lazy"' : ''}>`).join('');
  thumbs.innerHTML = imgs.map((s, i) => `<button aria-label="Show image ${i + 1}"${social.includes(i) ? ' class="is-social"' : ''}><img src="${s}" alt=""></button>`).join('');
  $('[data-total]').textContent = imgs.length;
  let gi = 0;
  const go = i => {
    gi = (i + imgs.length) % imgs.length;
    track.style.transform = `translateX(-${gi * 100}%)`;
    $('[data-idx]').textContent = gi + 1;
    $$('button', thumbs).forEach((b, j) => b.classList.toggle('active', j === gi));
  };
  $('.gallery__arrow.prev').onclick = () => go(gi - 1);
  $('.gallery__arrow.next').onclick = () => go(gi + 1);
  $$('button', thumbs).forEach((b, j) => b.onclick = () => go(j));
  let sx = null;
  track.addEventListener('pointerdown', e => sx = e.clientX);
  track.addEventListener('pointerup', e => {
    if (sx === null) return; const dx = e.clientX - sx; sx = null;
    if (Math.abs(dx) > 40) go(gi + (dx < 0 ? 1 : -1));
    else { const lb = $('[data-lightbox]'); $('img', lb).src = imgs[gi]; lb.hidden = false; }
  });
  let lastTouch = 0;
  ['pointerdown', 'touchstart'].forEach(ev => $('.gallery').addEventListener(ev, () => lastTouch = Date.now(), { passive: true }));
  setInterval(() => {
    if (document.hidden || !$('[data-lightbox]').hidden || Date.now() - lastTouch < 6000) return;
    go(gi + 1);
  }, 3000);
  $('[data-lightbox-close]').onclick = () => $('[data-lightbox]').hidden = true;
  $('[data-lightbox]').addEventListener('click', e => { if (e.target === e.currentTarget) e.currentTarget.hidden = true; });
  go(0);

  /* ---------- Bundle / subscribe / qty ---------- */
  const qtyInput = $('[data-qty-input]'), subBox = $('[data-subscribe]');
  const current = () => {
    const r = $('input[name=bundle]:checked');
    const sub = subBox.checked;
    const price = +r.dataset.price * (sub ? .75 : 1);
    return { id: r.value + (sub ? 's' : ''), name: r.dataset.name + (sub ? ' · Subscribe & Save' : ''), price, compare: +r.dataset.compare };
  };
  const updatePrice = () => {
    const c = current(), q = Math.max(1, +qtyInput.value || 1);
    $$('[data-atc-price]').forEach(el => el.textContent = money(c.price * q));
    $$('[data-atc-compare]').forEach(el => el.textContent = money(c.compare * q));
    $('[data-sticky-name]').textContent = c.name;
    $$('.bundle').forEach(b => b.classList.toggle('is-active', $('input', b).checked));
    const sub = subBox.checked, fmt = n => '$' + (Number.isInteger(n) ? n : n.toFixed(2));
    $$('.bundle').forEach(b => {
      const inp = $('input', b), p = +inp.dataset.price * (sub ? .75 : 1), cmp = +inp.dataset.compare, tubes = +inp.value * 2;
      $('.bundle__price b', b).textContent = fmt(p);
      $('.bundle__body small', b).textContent = `${tubes} Tubes · You save ${fmt(cmp - p)}`;
      b.classList.toggle('is-sub', sub);
    });
  };
  $$('input[name=bundle]').forEach(r => r.addEventListener('change', updatePrice));
  subBox.addEventListener('change', updatePrice);
  $$('[data-qty]').forEach(b => b.onclick = () => { qtyInput.value = Math.max(1, (+qtyInput.value || 1) + +b.dataset.qty); updatePrice(); });
  qtyInput.addEventListener('input', updatePrice);
  updatePrice();

  /* ---------- Cart (Shopify: real cart via the Ajax Cart API) ---------- */
  // Bundles: tier n = buy n tubes, get n tubes free (2n tubes). Variant IDs come from the product template.
  const TIERS = { 1: { price: 45, compare: 90 }, 2: { price: 90, compare: 180 }, 3: { price: 135, compare: 270 } };
  const FREE_SHIP = 70;
  const AK = window.AK || {};
  const V = AK.variants || {};
  const PV = AK.protectVariant || null;
  const tierByVariant = {}; Object.keys(V).forEach(t => { if (V[t]) tierByVariant[V[t]] = +t; });
  let sc = { items: [], item_count: 0, total_price: 0 };
  const api = (url, body) => fetch(url, body
    ? { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify(body) }
    : { headers: { Accept: 'application/json' } }).then(r => { if (!r.ok) throw new Error(r.status); return r.json(); });
  const refresh = () => api('/cart.js').then(c => { sc = c; renderCart(); return c; });
  const fail = () => toast("Couldn't update your cart. Please try again.");
  if (!PV) $('[data-cd-protect]').remove();

  let shipPct = 0;
  const setShip = pct => {
    const bar = $('[data-ship-bar]'), truck = $('[data-ship-truck]');
    bar.style.width = pct + '%'; truck.style.left = pct + '%';
    truck.classList.add('is-driving'); clearTimeout(setShip.t);
    setShip.t = setTimeout(() => truck.classList.remove('is-driving'), 1900);
    $('.ship-track').classList.toggle('is-full', pct >= 100);
  };
  // replay the drive from the left each time the cart opens
  const replayShip = () => {
    const bar = $('[data-ship-bar]'), truck = $('[data-ship-truck]');
    bar.style.transition = truck.style.transition = 'none';
    bar.style.width = '0%'; truck.style.left = '0%'; void bar.offsetWidth;
    bar.style.transition = truck.style.transition = '';
    setTimeout(() => setShip(shipPct), 60);
  };
  window.__akReplayShip = () => replayShip();

  const lines = () => sc.items.filter(it => it.variant_id !== PV).map(it => {
    const t = tierByVariant[it.variant_id] || 1;
    return { key: it.key, variant: it.variant_id, qty: it.quantity, t, price: it.final_line_price / 100, compare: TIERS[t].compare * it.quantity };
  });
  const renderCart = () => {
    const ls = lines();
    const protectLine = sc.items.find(it => it.variant_id === PV);
    const count = ls.reduce((a, l) => a + l.qty, 0);
    const total = ls.reduce((a, l) => a + l.price, 0);
    const compare = ls.reduce((a, l) => a + l.compare, 0);
    const saved = Math.max(0, compare - total);
    const badge = $('.cart-count'); badge.hidden = !count; badge.textContent = count;
    $('[data-cart-count]').textContent = count;
    $('[data-cart-empty]').hidden = !!count; $('[data-cart-foot]').hidden = !count;
    const prBtn = $('[data-cd-protect]'); if (prBtn) prBtn.hidden = !count;
    // Protection only makes sense with a mask in the cart: drop it if the mask was removed
    if (!count && protectLine && !renderCart.dropping) {
      renderCart.dropping = true;
      api('/cart/change.js', { id: protectLine.key, quantity: 0 })
        .then(c => { sc = c; renderCart(); }).catch(fail).finally(() => { renderCart.dropping = false; });
    }
    $('[data-cd-saving]').hidden = !(count && saved > 0);
    $('[data-cd-saving-amt]').textContent = money(saved);
    const left = FREE_SHIP - total;
    $('[data-ship-msg]').innerHTML = left > 0 ? `You're <b>${money(left)}</b> away from <b>FREE shipping</b>` : '🚚 You unlocked <b>FREE tracked shipping!</b>';
    shipPct = Math.min(100, total / FREE_SHIP * 100); setShip(shipPct);
    $('[data-cart-items]').innerHTML = ls.map(l => `
      <div class="cart-item cd__item">
        <img src="${IMG}tier-${l.t}.jpg" alt="">
        <div class="cd__item-info"><b>Collagen Overnight Veil Mask</b><small>Buy ${l.t} + Get ${l.t} FREE · ${l.t * 2} tubes</small>
          <div class="cd__tags"><span class="cd__tag cd__tag--free">${l.t} tube${l.t > 1 ? 's' : ''} FREE</span></div>
          <div class="qty"><button data-key="${l.key}" data-q="${l.qty - 1}" aria-label="Decrease">−</button><input value="${l.qty}" readonly aria-label="Quantity"><button data-key="${l.key}" data-q="${l.qty + 1}" aria-label="Increase">+</button></div></div>
        <div class="cd__item-price"><b>${money(l.price)}</b><s>${money(l.compare)}</s><em>Save ${money(l.compare - l.price)}</em><button class="rm" data-key="${l.key}" data-q="0">Remove</button></div>
      </div>`).join('');
    // Upsell: offer the next bundle up for the largest line that isn't already the top tier
    const up = ls.filter(l => l.t < 3 && V[l.t + 1]).sort((a, b) => b.t - a.t)[0];
    const us = $('[data-cd-upsell]');
    if (up) {
      // Upgrade applies to every unit on the line, so show the real amounts for that quantity
      const extra = (TIERS[up.t + 1].price - TIERS[up.t].price) * up.qty;
      const moreSave = ((TIERS[up.t + 1].compare - TIERS[up.t + 1].price) - (TIERS[up.t].compare - TIERS[up.t].price)) * up.qty;
      const each = up.qty > 1 ? ` (×${up.qty})` : '';
      us.hidden = false;
      us.innerHTML = `<p class="cd__upsell-head">🔥 Upgrade &amp; save more</p>
        <div class="cd__upsell-card"><img src="${IMG}tier-${up.t + 1}.jpg" alt="">
          <div><b>Buy ${up.t + 1} + Get ${up.t + 1} FREE${each}</b><small>${(up.t + 1) * 2 * up.qty} tubes · ${2 * up.qty} more tubes, ${up.qty} FREE</small><span class="cd__upsell-save">Save ${money(moreSave)} more · only +${money(extra)}</span></div>
          <button class="btn cd__upsell-btn" data-cd-upgrade="${up.variant}" data-cd-qty="${up.qty}" data-cd-tier="${up.t}">Upgrade</button></div>`;
    } else us.hidden = true;
    const addon = $('[data-cd-addon]'); if (addon) addon.hidden = true;
    // Protection + totals
    if (prBtn) { prBtn.classList.toggle('is-on', !!protectLine); prBtn.setAttribute('aria-pressed', !!protectLine); }
    $('[data-cd-protect-row]').hidden = !protectLine;
    const grand = sc.total_price / 100;
    $('[data-cart-total]').textContent = money(total);
    $('[data-cd-compare]').textContent = saved > 0 ? money(compare) : '';
    $('[data-cd-save-row]').textContent = '−' + money(saved);
    $('[data-cd-ship]').textContent = total >= FREE_SHIP ? 'FREE' : 'Calculated at checkout';
    $('[data-cd-grand]').textContent = money(grand);
    $('[data-cd-grand-btn]').textContent = money(grand);
  };
  $('#cart').addEventListener('click', e => {
    const q = e.target.closest('[data-key]'), upg = e.target.closest('[data-cd-upgrade]'), pr = e.target.closest('[data-cd-protect]'), co = e.target.closest('[data-checkout]');
    if (co) { window.location.href = '/checkout'; return; }
    if (q) { api('/cart/change.js', { id: q.dataset.key, quantity: +q.dataset.q }).then(c => { sc = c; renderCart(); }).catch(fail); return; }
    if (upg) {
      const from = +upg.dataset.cdUpgrade, qty = +upg.dataset.cdQty, to = V[+upg.dataset.cdTier + 1];
      const existing = sc.items.filter(it => it.variant_id === to).reduce((a, it) => a + it.quantity, 0);
      api('/cart/update.js', { updates: { [from]: 0, [to]: existing + qty } })
        .then(c => { sc = c; renderCart(); toast('Upgraded! More tubes, more savings ✓'); }).catch(fail);
      return;
    }
    if (pr && PV) {
      if (pr.dataset.busy) return; // ignore taps while the previous toggle is still saving
      pr.dataset.busy = '1';
      const line = sc.items.find(it => it.variant_id === PV);
      (line ? api('/cart/change.js', { id: line.key, quantity: 0 }) : api('/cart/add.js', { items: [{ id: PV, quantity: 1 }] }))
        .then(refresh).catch(fail).finally(() => { delete pr.dataset.busy; });
    }
  });
  $$('[data-atc]').forEach(btn => btn.addEventListener('click', () => {
    const c = current(), q = Math.max(1, +qtyInput.value || 1), t = +$('input[name=bundle]:checked').value;
    if (!V[t]) { fail(); return; }
    btn.disabled = true;
    api('/cart/add.js', { items: [{ id: V[t], quantity: q }] })
      .then(refresh)
      .then(() => {
        const badge = $('.cart-count'); badge.classList.remove('bump'); void badge.offsetWidth; badge.classList.add('bump');
        toast(`Added! You're saving ${money((c.compare - c.price) * q)} 🎉`); openDrawer('cart');
      })
      .catch(fail).finally(() => { btn.disabled = false; });
  }));
  refresh().catch(() => renderCart());

  const toastEl = $('[data-toast]'); let tt;
  function toast(msg) { toastEl.textContent = msg; toastEl.classList.add('show'); clearTimeout(tt); tt = setTimeout(() => toastEl.classList.remove('show'), 2200); }

  /* ---------- Before & After results ---------- */
  const results = [
    ['After 3 nights', 'Calm, dewy and softly lit. A three-night reset for tired-looking skin.', ['Calmer Look', 'Morning Glow']],
    ['After 1 week', 'Texture that looks smoother up close. Seven nights, one easy step.', ['Smoother Texture', 'Even Tone']],
    ['After 2 weeks', 'A more even, rested look. The two-week habit that feels like a facial.', ['Rested Look', 'Hydrated']],
    ['After 4 nights', 'Glossy, bouncy, wide-awake skin. Four nights of peel-and-glow.', ['Dewy Finish', 'Softer Feel']],
    ['After 1 month', 'A brighter-looking, more balanced tone. One month of quiet overnight work.', ['Brighter Look', 'Nightly Ritual']]
  ];
  const st = $('[data-slider-track]');
  // Real reviews: add { name, stars: 5, verified: true } as a 4th item for a card once you have the customer's review + written permission.
  st.innerHTML = results.map(([t, line, tags, real], i) => `
    <article class="review">
      <div class="ba ba--single"><img src="${IMG}results-${i + 1}.jpg" alt="Before and after, ${t.toLowerCase()}" width="1200" height="800" loading="lazy"></div>
      <div class="review__body">
        ${real ? `<div class="stars review__stars">${'★'.repeat(real.stars)}</div>` : ''}
        <div class="review__head"><b>${real ? real.name : t}</b>${real && real.verified ? '<small class="verified">✓ Verified Buyer</small>' : ''}</div>
        <p class="review__line">${line}</p>
        <div class="chips">${tags.map(x => `<span>${x}</span>`).join('')}</div>
      </div>
    </article>`).join('');
  const cards = $$('.review', st), dots = $('[data-dots]');
  dots.innerHTML = cards.map((_, i) => `<button aria-label="Go to review ${i + 1}"></button>`).join('');
  const dotBtns = $$('button', dots);
  const step = () => cards[0].offsetWidth + 20;
  dotBtns.forEach((b, i) => b.onclick = () => st.scrollTo({ left: i * step() }));
  $('.slider__btn.prev').onclick = () => st.scrollBy({ left: -step() });
  $('.slider__btn.next').onclick = () => st.scrollBy({ left: step() });
  const syncDots = () => { const i = Math.round(st.scrollLeft / step()); dotBtns.forEach((b, j) => b.classList.toggle('active', j === i)); };
  st.addEventListener('scroll', syncDots, { passive: true }); syncDots();
  let auto = setInterval(() => {
    st.scrollLeft + st.clientWidth >= st.scrollWidth - 5 ? st.scrollTo({ left: 0 }) : st.scrollBy({ left: step() });
  }, 5000);
  st.addEventListener('pointerenter', () => clearInterval(auto), { once: true });

  /* ---------- Marquee ---------- */
  const mq = $('[data-marquee]');
  const lif = [1, 2, 3, 4, 5, 1, 2, 3, 4, 5].map(n => `<img src="${IMG}happy-${n}.jpg" alt="Akyilia customer wearing the overnight veil" width="400" height="600" loading="eager" decoding="async" fetchpriority="low">`).join('');
  mq.innerHTML = lif + lif;

  /* ---------- Reveal + counters ---------- */
  const io = new IntersectionObserver(es => es.forEach(e => {
    if (!e.isIntersecting) return;
    e.target.classList.add('in');
    if (e.target.dataset.count) {
      const el = e.target, end = +el.dataset.count, ring = el.closest('.ring'), t0 = performance.now();
      const run = t => {
        const p = Math.min(1, (t - t0) / 1500), v = Math.round(end * (1 - Math.pow(1 - p, 3)));
        el.textContent = (el.dataset.prefix || '') + v + (el.dataset.suffix || '');
        ring.style.setProperty('--fill', v);
        if (p < 1) requestAnimationFrame(run);
      };
      requestAnimationFrame(run);
    }
    io.unobserve(e.target);
  }), { threshold: .2 });
  $$('.reveal,[data-count]').forEach(el => io.observe(el));

  /* ---------- FAQ: one open at a time ---------- */
  $$('.faq details').forEach(d => d.addEventListener('toggle', () => {
    if (d.open) $$('.faq details').forEach(o => o !== d && (o.open = false));
  }));

  /* ---------- Exit-intent card (desktop only, once per session, never with items in cart) ---------- */
  const exitEl = $('[data-exit]'), exitT0 = Date.now();
  const ssGet = k => { try { return sessionStorage.getItem(k); } catch { return null; } };
  const ssSet = (k, v) => { try { sessionStorage.setItem(k, v); } catch {} };
  const isDesktop = () => matchMedia('(min-width: 990px) and (hover: hover) and (pointer: fine)').matches;
  const cartHasItems = () => (+($('[data-cart-count]') || {}).textContent || 0) > 0;
  function closeExit() { if (exitEl && !exitEl.hidden) exitEl.hidden = true; }
  document.addEventListener('mouseout', e => {
    if (e.relatedTarget || e.clientY > 10) return;
    if (!isDesktop() || ssGet('ak_exit_shown') || Date.now() - exitT0 < 10000 || cartHasItems()) return;
    if ($('#cart').classList.contains('open') || !$('[data-lightbox]').hidden) return;
    ssSet('ak_exit_shown', '1'); exitEl.hidden = false; $('[data-exit-cta]').focus({ preventScroll: true });
  });
  $$('[data-exit-close]').forEach(b => b.onclick = closeExit);
  exitEl.addEventListener('click', e => { if (e.target === exitEl) closeExit(); });
  $('[data-exit-cta]').addEventListener('click', e => {
    e.preventDefault(); closeExit();
    $('#bundles').scrollIntoView({ behavior: 'smooth', block: 'start' });
  });
})();
